<template>
    <footer class="footer">
        <div class="container">
          <div class="content">
            <div class="left-section">
              <div class="logo">
                <AppLogo :fromDashboard= "fromDashboard =true"/>
              </div>
            </div>
            <div class="right-section">
              <div class="powered-by sm-regular">
                <p>powered by</p>
                <img src="@/assets/logos/pits-logo.png" class="pits-logo">
              </div>
            </div>
          </div>
          <div class="copyright">
            <hr>
            <p class="sm-regular">Copyright © {{store.MediAssistConfigManager.DomainName}}. All rights reserved.</p>
          </div>
        </div>
      </footer>
</template>

<script setup>
import { useMyStore } from '@/store/store.ts';
import AppLogo from "@/components/AppLogo.vue";
const store = useMyStore();
</script>

<style scoped lang="css">
.footer {
      width: 100%;
      height: fit-content;
      background: white;

      & .container {
        width: inherit;
        height: inherit;
        padding-block: 2rem;
        padding-block-end: 1rem;

        & .content {
          height: auto;
          width: auto;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          max-width: 1280px;
          margin-inline: auto;
          padding-bottom: 1rem;
          padding-inline: 1rem;

          @media (min-width: 481px) and (max-width: 1280px) {
            flex-direction: row;
          }

          @media (min-width: 1281px) {
            flex-direction: row;
          }

          & .left-section {
            height: inherit;
            width: auto;
            flex-grow: 1;
          }

          & .powered-by {
            margin: 1rem;

            & p {
              text-transform: capitalize;
              color: #787878;
              margin: 0;
            }

            & .pits-logo {
              margin-top: 7px;
              width: 44px;
              height: 44px;
            }
          }

          & .right-section {
            height: inherit;
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 7.125rem;

            @media (min-width: 481px) {
              gap: 5.75rem;
            }

            & ul {
              align-self: flex-start;
              list-style: none;
              display: flex;
              flex-direction: column;
              gap: 0.65rem;

              & a,
              & li {
                color: #050505;
                text-transform: capitalize;
                text-decoration: none;
                cursor: pointer;

                @media (max-width: 481px) {
                  font-size: 1rem;
                }
              }
            }
          }
        }

        & .copyright {
          width: inherit;
          display: flex;
          flex-direction: column;
          gap: 1rem;

          @media (max-width: 744px) {
            padding-inline: 1rem;
          }

          @media (min-width: 745px) {
            padding-inline: 3.125rem;
          }

          @media (min-width: 1281px) {
            padding-inline: 0;
            max-width: 1280px;
            margin-inline: auto;
          }

          & hr {
            height: 0.03125rem;
            background-color: rgba(10, 33, 68, 0.15);
            border: none;

            @media (max-width: 480px) {
              position: relative;
              left: 0;
              right: 0;
            }
          }

          & p {
            color: #8B8B8B;
            align-self: center;
            width: 100%;
            padding-inline: 1rem;
            text-align: center;

            @media (min-width: 481px) {
              width: auto;
              padding-inline: 0;
            }
          }
        }
      }
    }
    </style>